export default __webpack_public_path__ + "static/media/hero-bg.31d74def.jpg";